import { render, staticRenderFns } from "./EventSingle.vue?vue&type=template&id=1d213448&scoped=true&"
import script from "./EventSingle.vue?vue&type=script&lang=js&"
export * from "./EventSingle.vue?vue&type=script&lang=js&"
import style0 from "./EventSingle.vue?vue&type=style&index=0&id=1d213448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d213448",
  null
  
)

export default component.exports